import { JiraIcon, AzureDevOpsIcon } from "@/components/tiptap/components";
import type { SyncVendor } from "@/api/syncApi";

export interface VendorConfig {
    label: string;
    itemNoun: string;
    Icon: React.ComponentType<{ width?: number; height?: number }>;
}

export const VENDOR_CONFIG: Record<SyncVendor, VendorConfig> = {
    JIRA: { label: "Jira", itemNoun: "ticket", Icon: JiraIcon },
    AZURE_DEVOPS: { label: "Azure DevOps", itemNoun: "work item", Icon: AzureDevOpsIcon },
};

// SYNCED is included so select-all can re-push (re-sync) already-synced rows;
// excluded: REMOTE_CHANGED/CONFLICT (need review first), ORPHANED (explicit
// per-row "Push as new"), NOT_READY (no generated content to send).
export const PUSHABLE_STATUSES = new Set(["NOT_SYNCED", "LOCAL_CHANGED", "SYNCED"]);
